import * as z from "zod";

export const LSPriceRatesSchema = z.object({
	priceRateKey: z.string(),
	priceRateID: z.string(),
	priceRateName: z.string(),
	vehicleTypes: z.array(z.string()).nullable(),
});
